var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "postbox",
    width: 196.12,
    height: 196.12,
    viewBox: "0 0 196.12 196.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#455a64}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    fill: "#f44336",
    d: "M216.189 128h-98.06a6.131 6.131 0 0 0-6.129 6.129v110.317a6.131 6.131 0 0 0 6.129 6.129H259.09a6.131 6.131 0 0 0 6.129-6.129V177.03a49.079 49.079 0 0 0-49.03-49.03z",
    "data-name": "Path 7376",
    transform: "translate(-69.099 -78.97)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    fill: "#ffc107",
    d: "M119.159 0h-49.03A6.131 6.131 0 0 0 64 6.129v24.515a6.131 6.131 0 0 0 6.129 6.129h49.03a6.131 6.131 0 0 0 6.129-6.129V6.129A6.131 6.131 0 0 0 119.159 0z",
    "data-name": "Path 7377",
    transform: "translate(-39.485)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7378",
    d: "M70.129 65.578A6.131 6.131 0 0 1 64 59.449V6.129a6.129 6.129 0 1 1 12.257 0v53.32a6.131 6.131 0 0 1-6.128 6.129z",
    className: "cls-3",
    "data-name": "Path 7378",
    transform: "translate(-39.485)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7379",
    fill: "#d32f2f",
    d: "M49.03 128A49.079 49.079 0 0 0 0 177.03v67.416a6.131 6.131 0 0 0 6.129 6.129h85.8a6.131 6.131 0 0 0 6.129-6.129V177.03A49.079 49.079 0 0 0 49.03 128z",
    "data-name": "Path 7379",
    transform: "translate(0 -78.97)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18616",
    d: "M0 0H24.515V24.515H0z",
    className: "cls-3",
    "data-name": "Rectangle 18616",
    transform: "translate(110.317 171.605)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostbox);
export default __webpack_public_path__ + "static/media/postbox.9940f3a8019a90ef1e63bd189786890c.svg";
export { ForwardRef as ReactComponent };